import {FC, useContext, useEffect, useMemo, useRef, useState} from "react";
import { Button, Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import { AppContext } from "../appContext/AppContext";
import CustomTabMenu from "../component/CustomTabMenu";
import InputSearch from "../component/InputSearch";
import { TableCustom } from "../component/table/table-custom/TableCustom";
import "../phan-he-tiep-nhan-thanh-toan/PhanHeTiepNhan.scss";
import { columnsLichSuKham } from "../phan-he-xet-nghiem/const/constants";
import { ILichSuModel } from "../phan-he-xet-nghiem/models/DanhSachBenhNhanModels";
import { CODE, KEY_DS_TAB_TIEP_DON, RESPONSE_MESSAGE, SELECTION_MODE } from "../utils/Constant";
import "./PhanHeKhamBenh.scss";
import ThongTinBenhNhan from "./components/ThongTinBenhNhan";
import DSBenhNhanKhamBenh from "./components/phan-he-kham-benh/DSBenhNhanKhamBenh";
import { KHAM_BO_PHAN, MODULE_EXPAND } from "./constants/KhamBenh";
import {
  KEY_TAB_DS_TIEP_DON,
  danhSachMenu,
  danhSachTab,
} from "./constants/phan-he-kham-benh/ConstantPhanHeKhamBenh";
import { PhanHeTiepDonContext } from "./contexts/PhanHeTiepDonContext";
import { IBenhNhan, iBangKhamBenh } from "./models/DSBenhNhanKhamBenhModels";
import PhanHeNoiTruDieuTriContextProvider from "../phan-he-noi-tru-dieu-tri/PhanHeDieuTriContext";
import DynamicConentTab from "../phan-he-tiep-nhan-thanh-toan/components/tab-tiep-nhan/dynamic-content-tab";
import { Formik, FormikProps, useFormikContext } from "formik";
import { exportFormExpand, getConfigFormExpand, saveFormExpand, updateFormExpand } from "./services/PrintExportService";
import { toast } from "react-toastify";
import ButtonInPhieu from "../component/button-in-phieu";
interface Props {
  isLichSuKham?: boolean;
  childrenTab?: boolean;
}

export const PhanHeKhamBenh: FC<Props> = (props) => {
  const { setCurrentTab } =
    useContext(AppContext);
  const [benhNhanInfo, setBenhNhanInfo] = useState<IBenhNhan>();
  const [thongTinKhamBenh, setThongTinKhamBenh] = useState<any>({
    khamBoPhan: { ...KHAM_BO_PHAN },
  });
  const [statusChangedEvent, setStatusChangedEvent] = useState<number>();
  const [benhNhanList, setBenhNhanList] = useState<iBangKhamBenh[]>([]);
  const [thongTinChiPhi, setThongTinChiPhi] = useState<any>({});
  const [listDisabledTab, setListDisabledTab] = useState<string[]>([]);
  const [filter, setFilter] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<any>("1");
  const [listAdditionalTab, setListAdditionalTab] = useState<any[]>([]);

  const formRef = useRef<FormikProps<any>>(null);

  useEffect(() => {
    if (benhNhanInfo?.caseId) {
      setListDisabledTab([]);
    } else {
      let newArr = [...listDisabledTab];
      setListDisabledTab(newArr);
      setCurrentTab(KEY_TAB_DS_TIEP_DON.PHIEU_KHAM_BENH);
    }
  }, [benhNhanInfo?.caseId]);

  const statusChangedEventFunc = () =>  { setStatusChangedEvent(Math.random()); }

  const onSubmit = async (formName: any) => {
    try {
      const formValues = formRef.current?.values?.additionalForms?.[formName] ?? {};
      const { data } = formValues?.id
        ? await updateFormExpand(formValues.id, formValues)
        : await saveFormExpand(
            benhNhanInfo?.thongTinKhamBenh?.visitId,
            formName,
            formValues
          );
      if (data?.code === CODE.SUCCESS) {
        toast.success("Lưu thành công");
        formRef.current?.setFieldValue(`additionalForms.${formName}`, {
          ...formValues,
          id: data?.data?.id,
        });
      } else {
        toast.warning(RESPONSE_MESSAGE.ERROR);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const DynamicTabAction = (form: any, formName:string) => {
    if (!formName) return null;
    
    const formValues = form.additionalForms?.[formName];
    const formId = formValues?.id;
    
    return (
      <div className="d-flex gap-2">
        <Button
          className="btn-fill spaces px-16"
          onClick={() => {
            onSubmit(formName);
          }}
        >
          Lưu
        </Button>
        {formId && 
          <ButtonInPhieu
            fetchExport={exportFormExpand}
            params={{
              fileType: 'pdf',
              id: formId,
              termCode: formName,
            }}
            label="In"
            className="btn-fill spaces px-16"
          />
        }
      </div>
    );
  };

  const handleGetListTab = async () => {
    try {
      let tabs: any[] = [];
      let orderId = benhNhanInfo?.thongTinKhamBenh?.orderId;
      if (orderId) {
        let { data } = await getConfigFormExpand({
          orderId,
          moduleExpand: MODULE_EXPAND,
        });
        const rawData = data?.data;
        if (rawData) {
          let form = [];
          if (Array.isArray(rawData)) {
            form = rawData;
          } else if (typeof rawData === "string") {
            form = JSON.parse(rawData);
          }

          form?.forEach((item: any) => {
            tabs.push({
              title: item?.name,
              eventKey: item?.eventKey,
              component:
                <DynamicConentTab
                  visitId={benhNhanInfo?.thongTinKhamBenh?.visitId}
                  formName={item?.form}
                  className="h-calc-vh-350"
                  action={DynamicTabAction}
                />
            });
          });
          setListAdditionalTab(tabs);
        } else {
          setListAdditionalTab([]);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (benhNhanInfo?.thongTinKhamBenh?.id) {
      handleGetListTab();
    }
  }, [benhNhanInfo?.thongTinKhamBenh?.id]);

  const contextValue = useMemo(() => ({
    activeTab,
    benhNhanInfo,
    benhNhanList,
    statusChangedEvent,
    setBenhNhanInfo,
    setBenhNhanList,
    setThongTinChiPhi,
    setThongTinKhamBenh,
    statusChangedEventFunc,
    thongTinChiPhi,
    thongTinKhamBenh
  }), [
    activeTab,
    benhNhanInfo,
    benhNhanList,
    thongTinChiPhi,
    thongTinKhamBenh
  ]);

  return (
    <PhanHeTiepDonContext.Provider
      value={contextValue}
    >
      <PhanHeNoiTruDieuTriContextProvider>
        <div className="reception-list bg-gray">
          <div className="reception__header spaces">
            <Row className="phanHeTiepDon bg-light h-100">
              <div className="pe-0 dsBenhNhan spaces width-27_4 h-calc-vh-50">
                  <DSBenhNhanKhamBenh statusChangedEvent ={statusChangedEvent} filter={filter} setFilter={setFilter}/>
              </div>
              <div className="pl-0 ml-pt-0_6 spaces border width-72 ">
                <ThongTinBenhNhan />
                <div className="p-0">
                  <Formik
                    initialValues={{
                      additionalForms: {}
                    }}
                    onSubmit={() => { }}
                    innerRef={formRef}
                  >
                    <CustomTabMenu
                      className="tab-kham-benh"
                      danhsachTabs={[...danhSachTab, ...listAdditionalTab]}
                      keyDanhSachTabs={KEY_DS_TAB_TIEP_DON}
                      listDisabledTab={listDisabledTab}
                      childrenTab={true}
                      activeTab={activeTab}
                      onTabChange={(activeTab: any) => setActiveTab(activeTab)}
                    />
                  </Formik>
                </div>
              </div>
            </Row>
          </div>
        </div>
      </PhanHeNoiTruDieuTriContextProvider>
    </PhanHeTiepDonContext.Provider>
  );
};

export default PhanHeKhamBenh;
